// Types
// Components
import dayjs from 'dayjs';
import _ from 'lodash';
// Utils
import { hourMinuteToSecond, secondToHourMinute } from 'utils/timeConverter';
import type { TDirectPaddingRule } from '@timeedit/types/lib/types';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

export interface DirectPaddingProps {
  rule: TDirectPaddingRule;
  onChange: (rule: TDirectPaddingRule) => void;
}

const DirectPadding = ({ rule, onChange }: DirectPaddingProps) => {
  const startTime = _.get(rule, ['timeConditions', 0, 'startTime'], 0);
  const endTime = _.get(rule, ['timeConditions', 0, 'endTime'], 0);

  return (
    <div>
      <TEDrawerSection label="Padding">
        <div className="section-col">
          <TEInput.HoursMinuteInput
            value={secondToHourMinute(rule.paddingBefore)}
            onChange={(value) =>
              onChange({
                ...rule,
                paddingBefore: hourMinuteToSecond(value) || 0,
              })
            }
            label="Padding before"
            tooltip="Padding before"
            minuteStep={5}
            data-testid="padding-before"
          />
          <TEInput.HoursMinuteInput
            value={secondToHourMinute(rule.paddingAfter)}
            onChange={(value) =>
              onChange({
                ...rule,
                paddingAfter: hourMinuteToSecond(value) || 0,
              })
            }
            label="Padding after"
            tooltip="Padding after"
            minuteStep={5}
            data-testid="padding-after"
          />
        </div>
      </TEDrawerSection>
      <TEDrawerSection label="Time condition">
        <div className="section-col">
          <TEInput.Switch
            checked={!!rule.timeConditions}
            onChange={(val: boolean) => {
              onChange({
                ...rule,
                timeConditions: val
                  ? [{ startTime: 0, endTime: 0 }]
                  : undefined,
              });
            }}
            label="Time condition"
            tooltip="Time condition"
            data-testid="time-condition"
          />
          <p>Padding only applies to reservations that occur between:</p>
          <TEInput.TimePicker
            value={dayjs().startOf('day').add(startTime, 'second')}
            onChange={(val) =>
              onChange({
                ...rule,
                timeConditions: [
                  {
                    startTime:
                      (val && val.diff(dayjs().startOf('day'), 's')) || 0,
                    endTime,
                  },
                ],
              })
            }
            label="Activities that end after"
            tooltip="Activities that end after"
            disabled={!rule.timeConditions}
            data-testid="act-end-after"
            format={'HH:mm'}
            needConfirm={false}
            hideFooter
            minuteStep={5}
          />
          <TEInput.TimePicker
            value={dayjs().startOf('day').add(endTime, 'second')}
            onChange={(val) =>
              onChange({
                ...rule,
                timeConditions: [
                  {
                    endTime:
                      (val && val.diff(dayjs().startOf('day'), 's')) || 0,
                    startTime,
                  },
                ],
              })
            }
            label="Activities that start before"
            tooltip="Activities that start before"
            disabled={!rule.timeConditions}
            data-testid="act-start-before"
            format={'HH:mm'}
            hideFooter
            needConfirm={false}
            minuteStep={5}
          />
        </div>
      </TEDrawerSection>
    </div>
  );
};

export default DirectPadding;
